module.exports = __webpack_public_path__ + "img/icon-noCertificate.c3c3e2ba.png";